import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { getFieldsForCreateRequest } from 'components/form-multi/utils';

import { toggleSpinner } from 'actions/appAction';
import { initCalculator } from 'actions/calculatorAction';
import { updateFields } from 'actions/formAction';
import { updatePageMessages } from 'actions/messageAction';

import { FROM_COUNTRY_NAME } from 'constants/fieldsName';

import { apiFetchData, changeBrowserUrlWithOutReload } from 'helpers/api';
import { countryPropType } from 'helpers/customPropTypes';
import { getLangCountryPrefix, resolveArguments } from 'helpers/utils';

import { useHandleCloseDropdownMenu } from 'hooks/useHandleCloseDropdownMenu';

import { AmountRow } from './styles';
import PromoInputText from '../../no-auth/form/PromoInputText';
import PromoCountryList from '../CalculatorDropdown/PromoCountryList';

const RequestAmountFrom = (props) => {
    const [showCountryList, setShowCountryList] = useState(true);

    const wrapperRef = useRef(null);
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useHandleCloseDropdownMenu(wrapperRef);

    const getUrl = (country) => {
        const isLanding = props.isLanding;
        const currencyId = props.countryTo.currencies[0].id;
        const fromCode = isLanding ? country.seoNameFrom : country.code;
        const toCountry = props.countryTo;
        const toCode = isLanding ? toCountry.seoNameTo : toCountry.code;
        const dependedURI = isLanding ? resolveArguments(props.localeDependentURI, [fromCode, toCode]) : `/request/${fromCode}/${toCode}`;

        return `${isLanding ? getLangCountryPrefix(props.lang, props.country) : '/auth'}${dependedURI}?toCurrId=${currencyId}`;
    };

    useEffect(() => {
        setShowCountryList(true);
    }, [isOpenDropdownMenu]);

    const selectCountry = (e, country) => {
        e.preventDefault();
        props.toggleSpinner(true);
        setShowCountryList(true);

        setOpenDropdownMenu(false);

        const url = getUrl(country);
        apiFetchData(url)
            .then((data) => {
                props.updateFields(props.formName, getFieldsForCreateRequest(data));
                props.updatePageMessages(data.messages);
                props.initCalculator(data);
                changeBrowserUrlWithOutReload(url, data);
            })
            .finally(() => props.toggleSpinner(false));
    };

    return (
        <AmountRow ref={wrapperRef}>
            {isOpenDropdownMenu ? (
                <PromoCountryList
                    showCountryList={showCountryList}
                    countryList={props.countryList}
                    isFrom={true}
                    showCurrencies={false}
                    handlerSelectCountry={selectCountry}
                />
            ) : (
                <PromoInputText
                    field={props.fields[FROM_COUNTRY_NAME]}
                    customValue={props.countryBean.name}
                    formName={props.formName}
                    onClick={() => setOpenDropdownMenu(true)}
                    isPseudoSelect
                />
            )}
        </AmountRow>
    );
};

RequestAmountFrom.propTypes = {
    countryBean: countryPropType,
    countryList: PropTypes.arrayOf(countryPropType),
};

const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.form[ownProps.formName].fields,
        lang: state.language.lang,
        country: state.app.country,
        messages: state.messages.pageMessages,
    };
};
export default connect(mapStateToProps, { toggleSpinner, updateFields, initCalculator, updatePageMessages })(RequestAmountFrom);
